import React from 'react'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import {
  SCHEDULE_EVENT_TYPES,
  getScheduleEventColor,
} from 'pages/pga-coach/dashboard/todays-schedule/schedule-event-colors'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import AnalyticsCard from './analytics-card'
import useStyles from '../styles'

const RankedListCard = ({
  title,
  subtitle,
  items,
  eventType = SCHEDULE_EVENT_TYPES.PRIVATE,
  emptyMessage,
  errorMessage,
  loading,
  error,
  className,
}) => {
  const classes = useStyles()
  const accentColor = getScheduleEventColor(eventType)

  return (
    <AnalyticsCard
      title={title}
      subtitle={subtitle}
      className={className}
      loading={loading}
      error={error}
      errorMessage={errorMessage}
      empty={!items?.length}
      emptyMessage={emptyMessage}
      flushBody
    >
      <Box component="ul" className={classes.rankedList}>
        {items?.map(item => {
          const { action } = item
          const Body = item.onClick ? 'button' : 'div'
          const ActionIcon = action?.icon

          return (
            <Box component="li" key={item.id} className={classes.rankedRow}>
              <Body
                {...(item.onClick
                  ? { type: 'button', onClick: item.onClick }
                  : {})}
                className={clsx(
                  classes.rankedRowBody,
                  item.onClick && classes.rankedRowLink,
                  item.onClick && classes.rankedRowButton,
                  action && classes.rankedRowBodyWithAction,
                )}
              >
                <Box
                  className={classes.rankedAccentBar}
                  style={{ backgroundColor: accentColor }}
                />
                <Box className={classes.rankedMain}>
                  <Typography
                    component="span"
                    display="block"
                    className={classes.rankedName}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    component="span"
                    display="block"
                    className={classes.rankedDetail}
                  >
                    {item.detail}
                  </Typography>
                </Box>
                <Box className={classes.rankedTrailing}>
                  <Typography
                    component="span"
                    className={classes.rankedCaption}
                  >
                    {item.caption}
                  </Typography>
                  {action ? null : item.onClick ? (
                    <ChevronRightIcon
                      aria-hidden="true"
                      className={classes.rankedChevron}
                    />
                  ) : (
                    <Box component="span" className={classes.rankedChevron} />
                  )}
                </Box>
              </Body>
              {action ? (
                <Box className={classes.rankedAction}>
                  <Tooltip title={action.label}>
                    <IconButton
                      aria-label={`${action.label}: ${item.title}`}
                      className={classes.rankedActionButton}
                      onClick={action.onClick}
                    >
                      <ActionIcon aria-hidden="true" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ) : null}
            </Box>
          )
        })}
      </Box>
    </AnalyticsCard>
  )
}

export default RankedListCard
